/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-SelectionItemExample-check{display:inline-block;cursor:default;padding:11px 8px;box-sizing:border-box;vertical-align:top;background:0 0;border:none}.ms-SelectionItemExample:hover{background:#eee}.ms-SelectionItemExample-name{display:inline-block;overflow:hidden;height:36px;cursor:default;padding:8px;box-sizing:border-box;vertical-align:top;background:0 0;border:none}"}]);
/* tslint:enable */